let resolvedBackendUrl = process.env.REACT_APP_BE_URL || '';

/**
 * Gets the current resolved backend URL.
 */
export const getBackendUrl = (): string => {
  return resolvedBackendUrl;
};

/**
 * Resolves the backend URL by checking if a branch-specific endpoint is healthy.
 * Logic:
 * 1. Get branch from VERCEL_GIT_COMMIT_REF
 * 2. If branch starts with 'preview/', construct URL by prepending the branch name to the REACT_APP_BE_URL domain.
 * 3. Check /health
 * 4. Fallback to original REACT_APP_BE_URL
 */
export const resolveBackendUrl = async (): Promise<string> => {
  // In CRA, only REACT_APP_ prefixed vars are available by default.
  // We check both for maximum compatibility.
  const branch = process.env.REACT_APP_VERCEL_GIT_COMMIT_REF || (process.env as any).VERCEL_GIT_COMMIT_REF;
  const originalBeUrl = process.env.REACT_APP_BE_URL || '';

  if (branch && branch.startsWith('preview/')) {
    const name = branch.replace('preview/', '');

    // Construct URL by prepending the branch name to the originalBeUrl domain
    // 1. Remove protocol and trailing slashes from originalBeUrl
    const domain = originalBeUrl.replace(/^https?:\/\//, '').replace(/\/+$/, '');

    if (!domain) {
      console.warn('[BackendConfig] No domain found in REACT_APP_BE_URL, skipping preview URL construction');
      return originalBeUrl;
    }

    // 2. Prepend branch name (e.g. my-feature.api.staging.coverflowtech.com)
    const url = `https://${name}.${domain}`;

    try {
      console.log(`[BackendConfig] Checking health of dynamic preview backend: ${url}`);

      const controller = new AbortController();
      const id = setTimeout(() => controller.abort(), 3000);

      const response = await fetch(`${url}/health`, {
        method: 'GET',
        signal: controller.signal
      });

      clearTimeout(id);

      if (response.ok) {
        console.log(`[BackendConfig] Dynamic backend is healthy! Using: ${url}`);
        resolvedBackendUrl = url;
        return url;
      }
    } catch (e) {
      console.warn(`[BackendConfig] Health check failed for ${url}, falling back to ${originalBeUrl}`, e);
    }
  }

  resolvedBackendUrl = originalBeUrl;
  console.log(`[BackendConfig] Using default backend: ${resolvedBackendUrl}`);
  return originalBeUrl;
};
